export default {
  companyInfo: null, // 存储公司信息
  isLoading: false
}



// WEBPACK FOOTER //
// ./src/store/state.js